import { SVGIconDescriptor } from '../../SVG';
import {
  AccessibleStatus,
  AccessibleWarningStatus,
  CanceledStatus,
  ClusteredStatus,
  CompleteStatus,
  CompleteWithWarningsStatus,
  ConditionalCompleteStatus,
  ConditionalStatus,
  DebuggerChangeIndicator,
  DebugStatus,
  DefaultStatus,
  DisconnectedStatus,
  EmbeddedStatus,
  ErrorStatus,
  FlaggedStatus,
  HiddenStatus,
  HistoricalStatus,
  ImportantStatus,
  IncompleteInProgressStatus,
  IncompleteStatus,
  IncompleteWarningStatus,
  InformationStatus,
  InsightFoundStatus,
  InsightStatus,
  InvalidStatus,
  LockedStatus,
  LowPriorityStatus,
  MediumPriorityStatus,
  MergedStatus,
  NeutralStatus,
  NewStatus,
  OnDemandStatus,
  OutOfSyncStatus,
  PausedStatus,
  ProgressStatus,
  ReadOnlyStatus,
  RequiredStatus,
  RevertedStatus,
  ReviewStatus,
  ScheduledStatus,
  StoppedStatus,
  StoppingStatus,
  SubmittedStatus,
  Superuser,
  TrendDownStatus,
  TrendNoChangeStatus,
  TrendUpStatus,
  VisibleStatus,
  WarningStatus,
  FavoritedIndicator,
} from '@sas/react-svg';
import { NodeStatusIcon } from '../';

export const StatusIconMap: { [key in NodeStatusIcon]: SVGIconDescriptor } = {
  AccessibleStatus,
  AccessibleWarningStatus,
  CanceledStatus,
  ClusteredStatus,
  CompleteStatus,
  CompleteWithWarningsStatus,
  ConditionalCompleteStatus,
  ConditionalStatus,
  DebuggerChangeIndicator,
  DebugStatus,
  DefaultStatus,
  DisconnectedStatus,
  EmbeddedStatus,
  ErrorStatus,
  FlaggedStatus,
  HiddenStatus,
  HistoricalStatus,
  ImportantStatus,
  IncompleteInProgressStatus,
  IncompleteStatus,
  IncompleteWarningStatus,
  InformationStatus,
  InsightFoundStatus,
  InsightStatus,
  InvalidStatus,
  LockedStatus,
  LowPriorityStatus,
  MediumPriorityStatus,
  MergedStatus,
  NeutralStatus,
  NewStatus,
  OnDemandStatus,
  OutOfSyncStatus,
  PausedStatus,
  ProgressStatus,
  ReadOnlyStatus,
  RequiredStatus,
  RevertedStatus,
  ReviewStatus,
  ScheduledStatus,
  StoppedStatus,
  StoppingStatus,
  SubmittedStatus,
  Superuser,
  TrendDownStatus,
  TrendNoChangeStatus,
  TrendUpStatus,
  VisibleStatus,
  WarningStatus,
  FavoritedIndicator,
};
